import React, { useContext, useState } from 'react';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import CustomDialog from '../custom-dialog/custom-dialog';
import {
  DialogTitle,
  Typography,
  DialogContent,
  Stack,
  Button,
  CircularProgress,
  DialogActions,
  TextField,
  Box,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { format } from 'date-fns';
import { useSnackBar } from '../../../contexts/snackbar';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BulkActionProps } from './props.interface';



function FreezeOrderDialog({
  selectedOrders,
  bulkEndpoint,
  refetchOrders,
  onFinishAction,
}: BulkActionProps & {  onFinishAction: ()=>void;}) {
  const [reason, setReason] = useState('');
  const [until, setUntil] = useState<Dayjs | null>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { config } = useContext(AuthContext);
  const { showMessage } = useSnackBar();

  const freeze = async (date: Date, reason: string) => {
    try {
      setLoading(true);
      const response = await axios.post<OrderType>(
        `${API_ENDPOINT}/api/v1/orders/bulk-freeze/`,
        { until_datetime: date.toISOString(), reason: reason, order_ids: Array.from(selectedOrders.values()).map(o=>o.id) },
        config
      );
      showMessage(`Orders frozen until ${format(date, 'dd-MM-yyyy')}!`);
      refetchOrders(); 
      onFinishAction();
    } catch {
      showMessage('Failed to freeze orders', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError('');
    if (until == null) {
      showMessage('Please choose a date', 'error');
      return;
    }
    const untilDate = until.toDate();
    const now = new Date();

    if (!reason.trim()) {
      setError('Please enter a reason.');
      return;
    }

    if (!until || isNaN(untilDate.getTime()) || untilDate <= now) {
      showMessage('Choose a future date', 'error');
      return;
    }

    try {
      setLoading(true);
      await freeze(untilDate, reason);
    } catch (err) {
      setError('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography align={"center"}>
        {selectedOrders.size} Orders Selected
      </Typography>

    
        <Stack spacing={3} sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Unfreeze on"
              value={until}
              onChange={(newValue) => setUntil(newValue)}
            />
          </LocalizationProvider>

          <TextField
            label="Reason"
            fullWidth
            multiline
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />

          {error && (
            <Typography variant="body2" color="error">
              {error}
            </Typography>
          )}
        </Stack>


      
        <Button sx={{mt: 2}} onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : 'Freeze Orders'}
        </Button>

    </Box>
  );
}

export default FreezeOrderDialog;
